import { Campaign, Insights } from '@mui/icons-material'
import { Box, Grid, Skeleton, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import AlertHTMLContent from '../components/alert-html-content'
import { StyleHelper } from '../components/style-helper'
import { useError } from '../context/error'
import { AlertService } from '../services/alert.service'
import { CarnivoreAlert } from '../_types/alert.type'
import PageProps from '../_types/page-props.interface'
import useDocumentTitle from '../hooks/useDocumentTitle'

const _formateTime = (timestamp: number) => {
  const date = new Date(timestamp)
  return `${date.toLocaleDateString('en-US', {
    dateStyle: 'full'
  })} at ${date.toLocaleTimeString('en-US', { timeStyle: 'short' })}`
}

export default function AlertPage(props: PageProps) {
  useDocumentTitle(props.title)

  const params = useParams()
  const [localAlert, setLocalAlert] = useState<CarnivoreAlert | null>(null)
  const { setError } = useError()
  const alertService = new AlertService(setError)

  useEffect(() => {
    async function getAlertData() {
      const res = await alertService.getAlert(params.id!)
      setLocalAlert(res)
    }
    getAlertData()
  }, [])

  return (
    <Box padding={8}>
      <Grid container alignItems='center'>
        <Grid item xs={1} sx={{ textAlign: 'left' }}>
          {localAlert?.alertType === 'alert' ? (
            <Campaign color='primary' sx={{ fontSize: 36 }} />
          ) : (
            <Insights color='primary' sx={{ fontSize: 36 }} />
          )}
        </Grid>
        <Grid item xs={9} sx={{ textAlign: 'left' }}>
          <Typography color={'primary'} variant='h5' fontWeight={'bold'}>
            {localAlert?.subject}
          </Typography>
        </Grid>
      </Grid>
      <Typography variant='body2' sx={{ ml: 1 }}>
        {_formateTime(localAlert?.timeStamp ?? 0)}
      </Typography>
      <StyleHelper.VerticalSpace />

      {localAlert ? (
        <AlertHTMLContent html={localAlert.contentHTML} />
      ) : (
        <Box>
          <Skeleton variant='text' width='100%' />
          <Skeleton variant='text' width='90%' />
          <Skeleton variant='text' width='80%' />
          <Skeleton variant='text' width='70%' />
          <Skeleton variant='text' width='60%' />
        </Box>
      )}

      <StyleHelper.DoubleVerticalSpace />
    </Box>
  )
}
